import { API_SITE_CORPO } from "../api_endpoint";
import { http,httpwithtoken  } from '../http';

export const getAllMenu = async ( ) => {  
	try {
		let x=API_SITE_CORPO.MENU 
		let { data } = await http.get(x);
		
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
};

export const saveMenu = async (menu: any) =>{

	try {
		let endPoint= API_SITE_CORPO.MENU 
		let { data } = await httpwithtoken.post(endPoint, menu);
		return data;
	} catch (error) {
		console.error(error); 
		 
	}
}

export const importMenu = async (file: File) => {
	try {
		let x=API_SITE_CORPO.MENU +"/import"
		let { data } = await httpwithtoken.post(x, file);
		return data;
	} catch (error: any) {
		const errorMessage = error.response && error.response.data ? error.response.data.errors : 'An error occurred while processing your request. Please try again.';
		throw errorMessage; 
	}
}
